import BaseResource from '@/app-core/lib/data/resource/BaseResource'

export default class CustomerAddressResource extends BaseResource {
  constructor(payload = {}) {
    super(payload)

    this.Id = payload.Id ?? null
    this.CustomerId = payload.CustomerId ?? null
    this.Active = payload.Active ?? false
    this.City = payload.City ?? ''
    this.Comment = payload.Comment ?? ''
    this.DoorBell = payload.DoorBell ?? ''
    this.Floor = payload.Floor ?? ''
    this.Formatted = payload.Formatted ?? ''
    this.IsDefault = payload.IsDefault ?? false
    this.HasLatLngOnly = payload.HasLatLngOnly ?? false
    this.Lat = payload.Lat ?? ''
    this.Lng = payload.Lng ?? ''
    this.Nickname = payload.Nickname ?? ''
    this.Number = payload.Number ?? ''
    this.PlaceId = payload.PlaceId ?? ''
    this.Postcode = payload.Postcode ?? ''
    this.State = payload.State ?? ''
    this.Street = payload.Street ?? ''
    this.Country = payload.Country ?? ''
    this.CountryCode = payload.CountryCode ?? ''
    this.Provider = payload.Provider ?? ''
    this.ExtraFields = payload.ExtraFields ?? null
    this.useCustomAddress = payload?.useCustomAddress ?? false
  }

  /* PROPERTIES */

  /* METHODS */
}
